import { TableHeadItemRecurse } from '../../../../components/TableHead';

export const tableHeadWithdrawal: TableHeadItemRecurse[] = [
  { title: 'Data de solicitação', flex: 1 },
  { title: 'Data para saque', flex: 1 },
  { title: 'Valor(R$)', flex: 1 },
  { title: 'Status', flex: 1 },
  // { title: 'Comprovante', flex: 1 },
  { title: '', flex: 1 },
];
